import React, { PureComponent } from "react";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const data = [
  {
    name: "Feb",
    Generate: 4000,
    Redeem: 2400,
  },
  {
    name: "March",
    Generate: 3000,
    Redeem: 1398,
  },
  {
    name: "April",
    Generate: 2000,
    Redeem: 9800,
  },
  {
    name: "May",
    Generate: 2780,
    Redeem: 3908,
  },
  {
    name: "June",
    Generate: 1890,
    Redeem: 4800,
  },
  {
    name: "July",
    Generate: 2390,
    Redeem: 3800,
  },
  {
    name: "August",
    Generate: 3490,
    Redeem: 4300,
  },
];

const StuckBar = ({ data }: any) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        width={460}
        height={250}
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="title" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="redemeedCount" stackId="a" fill="#F06D24" />
        <Bar dataKey="totalCount" stackId="a" fill="#00AA67" />
      </BarChart>
    </ResponsiveContainer>
  );
};
export default StuckBar;
